import React, { useEffect, useState } from 'react'; 
import Select from 'react-select';
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Toast, ToastContainer } from "react-bootstrap";
import { faAngleDown, faAngleUp,  faExternalLinkAlt, faEye, faSearch } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Nav, Card, Image, Button, Table, InputGroup, Pagination, Spinner, Modal, Form, Alert } from '@themesberg/react-bootstrap';
import { Dropdown } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlusch, FaTrashAlt  } from "react-icons/fa";
import { BASE_URL } from '../../constants';
import axios from 'axios';
import RoomDetails from "../../components/RoomDetails";
import { useAuth } from '../../Context/AuthContext';
import Layout from "../../components/Layout";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import ConfirmDeleteModal from '../../components/DeleteModal';

const RoomsPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [occupants, setOccupants] = useState([]);
  const [occupantss, setOccupantss] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertVariant, setAlertVariant] = useState('success');
  const [showAlert, setShowAlert] = useState(false);
const [showEditModal, setShowEditModal] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [sortByFreePlaces, setSortByFreePlaces] = useState(false);
  const [loading, setLoading] = useState(true); // Loading state in parent
  const [error, setError] = useState(null);
  const [selectedOccupants, setSelectedOccupants] = useState([]);
  const [capacityExceeded, setCapacityExceeded] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [roomToDelete, setRoomToDelete] = useState(null);
  const { user } = useAuth();
  const navigate = useNavigate();
  const shelterId = user?.shelter.id;
  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);
  

  const [editForm, setEditForm] = useState({
    roomNumber: "",
    occupant: {
      firstName: "",
      lastName: "",
    },
    isOccupied: false,
    capacity: "",
  });
  const handleDeleteRoom = (roomId) => {
    setRoomToDelete(roomId);         
    setShowDeleteModal(true);      
    
  };
  
  const confirmDeleteRoom = async () => {
    setShowAlert(false);
    setAlertMessage('');
    setLoading(true); 
  
    try {
      const token = localStorage.getItem("token");
  
      // Wait for delete to complete
      await axios.delete(`${BASE_URL}/accommodation/${roomToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      // Success feedback
      setAlertMessage("Room deleted successfully!");
      setAlertVariant("success");
      setShowAlert(true);
  
      fetchRooms(); // refresh list
  
      // Close modal and clear selected room only after success
      setShowDeleteModal(false);
      setRoomToDelete(null);
  
    } catch (error) {
      setAlertMessage("Failed to delete room.");
      setAlertVariant("danger");
      setShowAlert(true);
      console.error("Error deleting room:", error);
    } finally {
      setLoading(false); 
    }
  };
  
  const [formData, setFormData] = useState({
    roomNumber: "",
    capacity: "",
  });

   // Fetch occupants
   const fetchOccupantss = async () => {
    if (!shelterId) return;
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/refugees/shelter/${shelterId}`);
      const refugees = response.data.filter(user => user?.isRefugee);
      // Apply search filter
      const filteredOccupants = refugees.filter((refugee) => { 
        return (
          refugee.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || 
          refugee.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          refugee.identifiant.toLowerCase().includes(searchQuery.toLowerCase()) 
        );
      });
      // Set filtered occupants to state
      setOccupantss(filteredOccupants);
    } catch (error) {
      console.error("Error fetching occupants data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch rooms
  const fetchRooms = async () => {
    setLoading(true);
    try {
      if (!shelterId) return;
  
      const response = await axios.get(`${BASE_URL}/accommodation/shelter/${shelterId}`);
      const allRooms = response.data.rooms;

      // Apply search filter on the full list of rooms
      const filteredRooms = allRooms.filter((room) => {
        // Filter by roomNumber
        const roomMatches = room.roomNumber.toLowerCase().includes(searchQuery.toLowerCase());
  
        // Filter by occupant's name or identifiant
        const occupantMatches = room.occupant?.some((o) => {
          const occupantName = (o.firstName || "") + " " + (o.lastName || "");
          const occupantLabel = occupantName.trim() || o.identifiant || "Unknown";
          return occupantLabel.toLowerCase().includes(searchQuery.toLowerCase());
        });
  
        return roomMatches || occupantMatches;
      });
  
      setRooms(filteredRooms); // Update filtered rooms
    } catch (error) {
      console.error("Error fetching rooms data:", error);
      setError(error.response?.data?.message || "Error fetching rooms");
    } finally {
      setLoading(false);
    }
  };


  const fetchOccupants = async () => {
    if (!shelterId) return;
    setLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/refugees/shelter/${shelterId}`);
      const refugees = response.data.filter(user => user?.isRefugee);
      
  
      // Apply search filter
      const filteredOccupants = refugees.filter((refugee) => { 
        return (
          refugee.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) || 
          refugee.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          refugee.identifiant?.toLowerCase().includes(searchQuery.toLowerCase()) 
        );
      });
  
      // Set filtered occupants to state
      setOccupants(filteredOccupants);
  
    } catch (error) {
      console.error("Error fetching occupants data:", error);
    } finally {
      setLoading(false);
    }
  };
  
  

  // Fetch data when shelterId changes or searchQuery changes
  useEffect(() => {
    if (shelterId) {
      fetchRooms();
      fetchOccupantss();
      fetchOccupants();
    }
  }, [searchQuery]);

  const handleOpenModal = (room) => {
    setSelectedRoom(room);
    setShowModal(true);
    setShowAlert(false);
    setAlertMessage("");
    setAlertVariant("success"); 
  };
  

  const handleCloseModal = () => {
    setSelectedRoom(null);
    setShowModal(false);
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedOccupants(selectedOptions);
    setEditForm((prev) => ({
      ...prev,
      isOccupied: selectedOptions.length > 0,
      occupant: selectedOptions.map((option) => ({
        firstName: option.label.split(" ")[0],
        lastName: option.label.split(" ")[1],
        identifiant: option.label.split(" ")[1],
        _id: option.value,
      })),
    }));
  };

  const occupantOptions = occupants.map((occupant) => {
    const name = `${occupant.firstName || ''} ${occupant.lastName || ''}`.trim();
    return {
      value: occupant._id,
      label: name ? name : occupant.identifiant || 'Unknown',
    };
  });
  
  
  
  const handleEdit = (room) => {
    setEditForm({
      _id: room._id,
      roomNumber: room.roomNumber,
      occupant: room.occupant || [],
      isOccupied: room.isOccupied,
      capacity: room.capacity,
    });

    setSelectedOccupants(
      room.occupant?.map((o) => ({
        value: o._id,
        label: o.firstName || o.lastName
          ? `${o.firstName || ""} ${o.lastName || ""}`.trim()
          : o.identifiant || "Unknown",
      })) || []
    );
    

    setShowEditModal(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "isOccupied") {
      const isOccupied = value === "true";
      setEditForm((prev) => ({
        ...prev,
        isOccupied: isOccupied,
        occupant: isOccupied ? prev.occupant : { firstName: "", lastName: "", identifiant: "" },
      }));
    } else if (name.startsWith("occupant.")) {
      const key = name.split(".")[1];
      setEditForm((prev) => {
        const newOccupant = { ...prev.occupant, [key]: value };
        const hasName = newOccupant.firstName || newOccupant.lastName;
        const hasIdentifiant = newOccupant.identifiant;
  
        return {
          ...prev,
          occupant: newOccupant,
          isOccupied: hasName || hasIdentifiant ? true : false,
        };
      });
    } else {
      setEditForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
  const handleSaveChanges = async () => {
    setShowAlert(false); 
    setAlertMessage('');
    try {
      const user = JSON.parse(localStorage.getItem('userData'));
      const token = localStorage.getItem('token');

      if (!user || !user.isAdmin) {
        setAlertMessage('You do not have permission to perform this action.');
        setAlertVariant('danger');
        setShowAlert(true);
        return;
      }

      const updatedRoom = {
        roomNumber: editForm.roomNumber,
        capacity: editForm.capacity,
        occupant: editForm.occupant,
        isOccupied: editForm.isOccupied,
      };

      await axios.put(
        `${BASE_URL}/accommodation/${editForm._id}`,
        updatedRoom,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setRooms((prev) =>
        prev.map((room) =>
          room._id === editForm._id ? { ...editForm, _id: room._id } : room
        )
      );
      await fetchRooms(); // re-fetch the latest room data from backend

      setAlertMessage('Room updated successfully!');
      setAlertVariant('success');
      setShowAlert(true);
      setShowEditModal(false);
  

    } catch (error) {
      let errorMessage = 'An error occurred. Please try again later.';
      if (error.response) {
        errorMessage = error.response.data.message || 'Failed to update room.';
      } else if (error.request) {
        errorMessage = 'No response from server. Please check your connection.';
      }

      setAlertMessage(errorMessage);
      setAlertVariant('danger');
      setShowAlert(true);
    }
  };
  const sortRoomsByFreePlaces = (rooms, descending = true) => {
    return [...rooms].sort((a, b) =>
      descending ? b.freePlaces - a.freePlaces : a.freePlaces - b.freePlaces
    );
  };
  
  const indexOfLastRoom = currentPage * itemsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - itemsPerPage;
  
  const sortedRooms = sortRoomsByFreePlaces(rooms, sortByFreePlaces);
  const currentRooms = sortedRooms.slice(indexOfFirstRoom, indexOfLastRoom);
  
 
  const totalPages = Math.ceil(sortedRooms.length / itemsPerPage);
  


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmitRoom = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${BASE_URL}/accommodation/addRoom`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shelterId: shelterId,
          roomNumber: formData.roomNumber,
          capacity: formData.capacity,
        }),
      });

      if (response.ok) {
        const newRoom = await response.json();
        setAlertMessage("Room added successfully!");
        setAlertVariant("success");
        setShowAlert(true);
        setFormData({ roomNumber: "", capacity: "" });
        setShowModalAdd(false);
        setTimeout(() => {    
          setShowAlert(false);
        }, 2000);
  
        setRooms((prevRooms) => [newRoom, ...prevRooms]);

        setRooms((prevRooms) => [newRoom, ...prevRooms]);

        await fetchRooms(); 
      } else {
        const error = await response.json();
        setAlertMessage(`Error: ${error.message || "Failed to add room."}`);
        setAlertVariant("danger");
        setShowAlert(true);
      }
    } catch (error) {
      console.error("Error adding room:", error);
      setAlertMessage("An unexpected error occurred.");
      setAlertVariant("danger");
      setShowAlert(true);
       } finally {
        setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-2">
      </div>
       <div className="table-settings mb-4">
  <Button onClick={() => setShowModalAdd(true)} variant="cyan">
    <FontAwesomeIcon icon={faPlus} className="me-2" />
    <span className="small">Add New Room</span>
  </Button>
</div>
<Col>
  <div className="btn-toolbar mb-2 mb-md-0">
  <InputGroup className="w-md-50 me-md-3 mb-2 mb-md-0">
      <InputGroup.Text>
        <FontAwesomeIcon icon={faSearch} />
      </InputGroup.Text>
      <Form.Control
        type="text"
        placeholder="Search by occupant or room number"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </InputGroup>
  <Button
  variant="outline-cyan"
  onClick={() => setSortByFreePlaces((prev) => !prev)}
  className="mt-2 mt-md-0 ms-md-2 px-2 py-1"
  style={{ minWidth: "90px", fontSize: "0.85rem" }}
>
  Sort by Free Places {sortByFreePlaces ? "▲" : "▼"}
</Button>

        </div>
      </Col>
      <>
      {loading ? (
        <div className="text-center my-4">
        <div className="spinner-border text-primary" role="status" />
      </div>
      
      ) : rooms.length > 0 ? (
        
        <Card border="light" className="shadow-sm mt-3" style={{ maxHeight: "500px" }}>
          <Card.Body className="pt-0">
            <Table hover responsive>
              <thead>
                <tr>
                  <th scope="col">Room Number</th>
                  <th scope="col">Capacity</th>
                  <th scope="col">Free</th>
                  <th scope="col">Occupied</th>
                  <th scope="col">Occupant</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentRooms.map((room) => {
                  return (
                    <tr key={room._id}>
                      <td><p className="text-muted mb-0">{room.roomNumber}</p></td>
                      <td><p className="text-muted mb-0">{room.capacity}</p></td>
                      <td><p className="text-muted mb-0">{room.freePlaces}</p></td>
                      <td><p className="text-muted mb-0">{room.occupiedPlaces}</p></td>
                      <td>
  <p className="text-muted mb-0">
    {room.occupant && room.occupant.length > 0
      ? room.occupant
          .map((o) => {
            const hasName = o.firstName || o.lastName;
            return hasName
              ? `${o.firstName || ""} ${o.lastName || ""}`.trim()
              : o.identifiant;
          })
          .join(", ")
      : "Vacant"}
  </p>
</td>

                      <td>
                        <Button className="me-2 btn-primary btn-sm" onClick={() => handleEdit(room)}>
                          <FaEdit />
                        </Button>
                      {/*  <Button
                          key={room._id}
                          className="me-2 btn-primary btn-sm"
                          onClick={() => handleOpenModal(room)}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>*/}
               <Button variant="danger" className="me-2 btn-primary btn-sm" onClick={() => handleDeleteRoom(room._id)}>
  <FaTrashAlt />
</Button>


                   
                      </td>
                      

                    </tr>
                    
                  );
                })}
              </tbody>
              <ConfirmDeleteModal
  show={showDeleteModal}
  onClose={() => setShowDeleteModal(false)}
  onConfirm={confirmDeleteRoom}
  itemName={`Room ${rooms.find((room) => room._id === roomToDelete)?.roomNumber || 'N/A'}`}
  loading={loading} 
/>
            </Table>

            <Pagination className="mt-3">
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {[...Array(totalPages).keys()].map((page) => (
                <Pagination.Item
                  key={page + 1}
                  active={page + 1 === currentPage}
                  onClick={() => handlePageChange(page + 1)}
                >
                  {page + 1}
                </Pagination.Item>
              ))}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Card.Body>
        </Card>
      ) : (
        <div className="card mt-3">
          <div className="card-body">
            <p className="card-text">No rooms available. Please add rooms to proceed.</p>
          </div>
        </div>
      )}
     <RoomDetails
        show={showModal}
        onHide={handleCloseModal}
        room={selectedRoom}
        loading={loading}  
      />
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Room Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formRoomNumber">
              <Form.Label>Room Number</Form.Label>
              <Form.Control
                type="text"
                name="roomNumber"
                value={editForm.roomNumber}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formCapacity">
              <Form.Label>Capacity</Form.Label>
              <Form.Control
                type="text"
                name="capacity"
                value={editForm.capacity}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Occupants</Form.Label>
              <Select
                isMulti
                name="occupants"
                options={occupantOptions}
                value={selectedOccupants}
                onChange={(selectedOptions) => {
                  setSelectedOccupants(selectedOptions);
                  if (selectedOptions.length > editForm.capacity) {
                    setCapacityExceeded(true);
                  } else {
                    setCapacityExceeded(false);
                  }
                  handleSelectChange(selectedOptions);
                }}
                classNamePrefix="react-select"
              />
            </Form.Group>
            <div className="mt-2">
          

            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSaveChanges} disabled={capacityExceeded}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
      
    <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
  <Modal.Header closeButton>
    <Modal.Title>Add New Room</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form onSubmit={handleSubmitRoom}>
      <Form.Group>
        <Form.Label>
          Room Number *
        </Form.Label>
        <Form.Control
          type="text"
          name="roomNumber"
          value={formData.roomNumber}
          onChange={handleChange}
          placeholder="Enter room number"
          required 
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>
          Capacity *
        </Form.Label>
        <Form.Control
          type="text"
          name="capacity"
          value={formData.capacity}
          onChange={handleChange}
          placeholder="Enter capacity"
          required
        />
      </Form.Group>
     <Button
  variant="primary"
  type="submit"
  className="mt-3"
  disabled={loading}
>
  {loading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
 
    </>
  ) : (
    "Add Room"
  )}
</Button>

    </Form>
  

  </Modal.Body>
</Modal>
<ToastContainer position="top-end" className="p-3">
  <Toast
    onClose={() => setShowAlert(false)}
    show={showAlert}
    delay={3000}
    autohide
    bg={alertVariant || "success"}
  >
    <Toast.Body className="text-white">{alertMessage}</Toast.Body>
  </Toast>
</ToastContainer>
    </Layout>
  );
};

export default RoomsPage;
